module.exports = __webpack_public_path__ + "img/arrow.png?141ae8148a1c5dbf83f2990c29a4d70f";